export default "<div id=\"breadcrumb-item\" *ngFor=\"let item of breadcrumbService.breadcrumbArray\">{{item}} {{breadCrumbText}}</div>";